export default __webpack_public_path__ + "static/media/telegram.14cbacdc.svg";